import { gql } from "@apollo/client";
export const AGENTS_WITH_FILTER = gql`
  query (
    $operatorId: ID!
    $lastName: String
    $firstName: String
    $agentMobile: String
    $partnerId: ID
    $partnerBranchId: ID
    $partnerBranchIds: [ID]
    $partnerCategoryId: ID
    $agentStatus: Int
    $withApp: Int
    $verifiedStatus: [Int]
    $signupDateFrom: Date
    $signupDateInto: Date
  ) {
    agentsWithFilter(
      operatorId: $operatorId
      lastName: $lastName
      firstName: $firstName
      agentMobile: $agentMobile
      partnerId: $partnerId
      partnerBranchId: $partnerBranchId
      partnerBranchIds: $partnerBranchIds
      partnerCategoryId: $partnerCategoryId
      agentStatus: $agentStatus
      withApp: $withApp
      verifiedStatus: $verifiedStatus
      signupDateFrom: $signupDateFrom
      signupDateInto: $signupDateInto
    ) {
      firstName
      lastName
      suffixName
      agentName
      middleName
      agentMobile
      agentStatus
      verifiedStatus
      signupDate
      partnerBranch {
        partnerBranchId
        partnerBranch
        __typename
      }
      partnerAgentId
      loadBalance
      createdAt
      updatedAt
      agentStatusComments
      comments
      walletBalance
      rejectedIdPics
      lastDropoffLocker
      lastDropoffDate
      businessPartnerId
      partnerCompanyName
      affiliationStatus
      __typename
    }
  }
`;

export const BROADCAST_AGENT_WITH_FILTER = gql`
  query (
    $operatorId: ID!
    $lastName: String
    $firstName: String
    $agentMobile: String
    $partnerId: [ID]
    $partnerBranchId: ID
    $agentStatus: Int
    $withApp: Int
    $verifiedStatus: Int
    $signupDateFrom: Date
    $signupDateInto: Date
  ) {
    broadcastAgentsWithFilter(
      operatorId: $operatorId
      lastName: $lastName
      firstName: $firstName
      agentMobile: $agentMobile
      partnerId: $partnerId
      partnerBranchId: $partnerBranchId
      agentStatus: $agentStatus
      withApp: $withApp
      verifiedStatus: $verifiedStatus
      signupDateFrom: $signupDateFrom
      signupDateInto: $signupDateInto
    ) {
      firstName
      lastName
      suffixName
      agentMobile
      agentStatus
      verifiedStatus
      signupDate
      partnerBranch {
        partnerBranchId
        partnerBranch
      }
      partnerAgentId
      loadBalance
    }
  }
`;

export const PARTNERS = gql`
  query ($operatorId: ID!) {
    partners(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const BRANCHES = gql`
  query ($operatorId: ID!, $partnerId: ID) {
    partnerBranches(operatorId: $operatorId, partnerId: $partnerId) {
      partnerBranchId
      partnerBranch
      address
      contactPerson
      contactPerson2
      landline
      landline2
      mobile
      mobile2
      loadBalance
      branchLevel
    }
  }
`;

// signupDetails
export const GET_AGENT_BY_ID = gql`
  query ($agentId: Int!) {
    getAgentById(agentId: $agentId) {
      firstName
      partnerAgentId
      middleName
      lastName
      signupDetails
      suffixName
      rejectedIdPics
      employeeId
      agentMobile
      agentEmail
      birthDate
      createdAt
      verifiedOn
      updatedAt
      verifiedStatus
      affiliationStatus
      agentStatus
      loadBalance
      walletBalance
      agentStatusComments
      comments
      partner {
        companyNickname
        partnerId
        __typename
      }
      partnerBranch {
        partnerBranchId
        partnerBranch
        __typename
      }
      suspiciousMobiles {
        partnerAgentSuspiciousMobileId
        agentMobile
        createdAt
        updatedAt
        __typename
      }
      relatedUserAccounts {
        userMobile
        userId
        firstName
        lastName
        userStatus
        comments
      }
      idPhotoUrl
      suspiciousMobileCheck {
        isSuspicious
        linkedAgents {
          firstName
          lastName
          middleName
          partnerAgentId
          createdAt
          suspiciousRecordId
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const AGENT_STATUS_HISTORY = gql`
  query (
    $partnerAgentId: ID!
    $verifiedStatus: Boolean
    $agentStatus: Boolean
  ) {
    agentStatusHistory(
      partnerAgentId: $partnerAgentId
      verifiedStatus: $verifiedStatus
      agentStatus: $agentStatus
    ) {
      partnerAgentStatusHistoryId
      partnerAgentId
      agentStatus
      verifiedStatus
      agentStatusComments
      comments
      createdAt
    }
  }
`;

export const FETCH_AGENT_VERIFICATION_HISTORY = AGENT_STATUS_HISTORY;

export const SAVE_STATUS_HISTORY = gql`
  mutation ($agentStatusHistoryArgs: [SaveAgentStatusHistoryObject]!) {
    saveAgentStatusHistory(agentStatusHistoryArgs: $agentStatusHistoryArgs) {
      agentStatusHistory {
        partnerAgentStatusHistoryId
        partnerAgentId
        agentStatus
        verifiedStatus
        agentStatusComments
        comments
        createdAt
      }
    }
  }
`;

export const UPDATE_AGENT = gql`
  mutation (
    $operatorId: ID!
    $agentStatus: Int
    $partnerAgentId: ID!
    $partnerId: ID
    $partnerBranchId: ID
    $verifiedStatus: Int
    $comments: String
    $rejectedIdPics: [Int]
  ) {
    updateAgent(
      operatorId: $operatorId
      agentStatus: $agentStatus
      partnerAgentId: $partnerAgentId
      partnerId: $partnerId
      partnerBranchId: $partnerBranchId
      verifiedStatus: $verifiedStatus
      comments: $comments
      rejectedIdPics: $rejectedIdPics
    ) {
      partnerAgent {
        firstName
        middleName
        lastName
        suffixName
        agentMobile
        agentEmail
        birthDate
        createdAt
        verifiedOn
        verifiedStatus
        agentStatus
        loadBalance
        agentStatusComments
        comments
        rejectedIdPics
        partner {
          partnerId
        }
        partnerBranch {
          partnerBranchId
        }
        idPhotoUrl
      }
    }
  }
`;

export const PACKAGE_DROPOFF_STATUS_HISTORY = gql`
  query (
    $operatorId: ID!
    $partnerAgentId: ID
    $dateStart: Date!
    $dateEnd: Date!
    $limit: Int
  ) {
    packageDropoffStatusHistory(
      operatorId: $operatorId
      partnerAgentId: $partnerAgentId
      dateStart: $dateStart
      dateEnd: $dateEnd
      limit: $limit
    ) {
      packageId
      locker
      waybill
      recipient
      dropoff
      status
      statusDate
      elapsedHrs
      partner
      history
    }
  }
`;
